import { RegisterActivityRetroactivelyForm } from "@/forms/AddActivityForm/RegisterActivityRetroactivelyForm/RegisterActivityRetroactivelyForm";
import { type IPatientId } from "@medoma/models/patients";
import {
  canRegisterActivitiesRetroactively,
  useNewActivityOutletContext,
} from "./newActivityUtils";
import { Text } from "@medoma/components/Text/Text";
import { Trans } from "@lingui/react/macro";
import { useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { deducedError } from "@/Utils/ErrorUtils";
import { usePatient } from "@/api/Patients";

const RetroactiveActivity = () => {
  const { patientId } = useNewActivityOutletContext();

  return (
    <>
      {patientId ? (
        <WithPatientId patientId={patientId} />
      ) : (
        <WithoutPatientId />
      )}
    </>
  );
};

const WithPatientId = ({ patientId }: { patientId: IPatientId }) => {
  const { data: patient, isPending, isError, error } = usePatient(patientId);
  const { t } = useLingui();

  if (isPending) {
    return <Loading message={t`Hämtar information om patient`} />;
  }

  if (isError) {
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta information om patient`} ${deducedError(error)}`}
      />
    );
  }

  if (!canRegisterActivitiesRetroactively(patient)) {
    return (
      <Text element="p" color="faded">
        <Trans>
          Efterregistrering är endast tillgänglig för inskrivna och utskrivna
          patienter. Använd <strong>Mallar</strong> eller{" "}
          <strong>Anpassad</strong> för att skapa aktiviteter för den här
          patienten.
        </Trans>
      </Text>
    );
  }

  return <RegisterActivityRetroactivelyForm patientId={patientId} />;
};

const WithoutPatientId = () => (
  <Text element="p" color="no-results">
    <Trans>Välj en patient för att efterregistrera en aktivitet</Trans>
  </Text>
);

export { RetroactiveActivity };
